import React, {Fragment} from 'react';
import {getHibuTextLightColor, getHibuThemeColor} from '../utils/utils';

const hibuThemeColor = getHibuThemeColor();
const hibuTextLightColor = getHibuTextLightColor();

// *******************************************************
// RAIL
// *******************************************************
type SliderRailProps = {
    getRailProps: () => Record<string, any>;
};

export function SliderRail({getRailProps}: SliderRailProps): React.JSX.Element {
    return (
        <Fragment>
            <div className="slider-rail-outer" {...getRailProps() || {}} />
            <div className="slider-rail-inner" />
        </Fragment>
    );
}

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
type HandleProps = {
    domain: number[];
    handle: {
        id: string;
        value: number;
        percent: number;
    };
    getHandleProps: (id: string) => Record<string, any>;
    disabled?: boolean;
};

export function Handle({
    domain: [min, max],
    handle: {id, value, percent},
    disabled,
    getHandleProps,
}: HandleProps): React.JSX.Element {
    return (
        <Fragment>
            <div
                style={{
                    left: `${percent}%`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                    zIndex: 5,
                    width: 24,
                    height: 42,
                    cursor: 'pointer',
                    backgroundColor: 'none',
                }}
                {...getHandleProps(id) || {}}
            />
            <div
                role="slider"
                aria-valuemin={min}
                aria-valuemax={max}
                aria-valuenow={value}
                style={{
                    left: `${percent}%`,
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 2,
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    border: `1px solid ${hibuThemeColor}`,
                    backgroundColor: disabled ? hibuTextLightColor : '#fff',
                }}
            />
        </Fragment>
    );
}

// *******************************************************
// TRACK COMPONENT
// *******************************************************
type TrackProps = {
    source: {
        id: string;
        value: number;
        percent: number;
    };
    target: {
        id: string;
        value: number;
        percent: number;
    };
    getTrackProps: () => Record<string, any>;
    disabled?: boolean;
};

export function Track({source, target, getTrackProps, disabled}: TrackProps): React.JSX.Element {
    return (
        <div
            style={{
                position: 'absolute',
                transform: 'translate(0%, -50%)',
                height: 2,
                zIndex: 1,
                backgroundColor: disabled ? hibuTextLightColor : hibuThemeColor,
                borderRadius: 4,
                cursor: 'pointer',
                left: `${source.percent}%`,
                width: `${target.percent - source.percent}%`,
            }}
            {...(getTrackProps() || {})}
        />
    );
}
